import type { LandingPageContent } from '../types'

export const COMPARAR_PRESUPUESTOS_FOTOVOLTAICOS: LandingPageContent = {
  slug: 'comparar-presupuestos-fotovoltaicos',
  lang: 'es',
  topicId: 'pv-angebot-vergleichen',
  title: 'Comparar presupuestos fotovoltaicos – gratis y sin acoso',
  metaDescription:
    'Compare varios presupuestos fotovoltaicos de empresas instaladoras - de forma anónima y sin ' +
    'que su número se entregue a todo el mundo.',
  keywords: [
    'comparar presupuestos fotovoltaicos',
    'comparar ofertas placas solares',
    'pedir presupuestos instalación solar',
    'comparar presupuestos solares sin llamadas',
  ],
  eyebrow: 'Así funciona la comparación',
  h1: 'Comparar presupuestos fotovoltaicos – sin acoso telefónico, sin compromiso',
  intro:
    'En los portales de comparación clásicos, la misma solicitud suele llegar a varias empresas a ' +
    'la vez - y enseguida el teléfono no para de sonar durante días. Roofora funciona de otra manera: ' +
    'usted permanece en el anonimato hasta que decide personalmente quién puede contactarle.',
  sections: [
    { type: 'heading', text: 'Así funciona la comparación de presupuestos en Roofora' },
    {
      type: 'list',
      items: [
        'Crear la solicitud: fotos del tejado, foto del cuadro eléctrico, orientación y consumo',
        'Publicación anónima: las empresas instaladoras ven la solicitud, pero no sus datos de contacto',
        'Las empresas envían presupuestos a precio cerrado y sin compromiso, y pueden mejorarlos en cualquier momento',
        'Usted compara los presupuestos ordenados por precio, con toda calma',
        'El contacto solo se produce si usted da su consentimiento activo a una empresa concreta',
      ],
    },
    { type: 'heading', text: 'Por qué las solicitudes anónimas dan mejores precios' },
    {
      type: 'paragraph',
      text:
        'Las empresas instaladoras ven cuántos presupuestos se han enviado ya - no sus precios. Esto ' +
        'genera una competencia real por su proyecto, sin que nadie utilice su número de teléfono ' +
        'antes de que usted haya visto siquiera un presupuesto.',
    },
    { type: 'heading', text: 'Usted decide quién puede contactarle' },
    {
      type: 'paragraph',
      text:
        'Si una empresa instaladora quiere hablar con usted, envía una solicitud de contacto. Usted ' +
        've su perfil y decide individualmente si esa empresa en concreto recibe sus datos de contacto ' +
        '- sin autorización general para todas.',
    },
    { type: 'heading', text: 'En qué fijarse al comparar' },
    {
      type: 'list',
      items: [
        'El precio en el contexto del paquete completo, no solo el importe final',
        'Los módulos e inversor utilizados',
        'El alcance de la garantía en material y montaje',
        'Valoraciones de proyectos anteriores',
        'Lo concreto y comprensible que resulta el desglose del presupuesto',
      ],
    },
    { type: 'heading', text: 'No solo sistemas completos: también se pueden pedir servicios sueltos' },
    {
      type: 'paragraph',
      text:
        'No tiene que solicitar un sistema completo. Si ya tiene los módulos o los consigue usted ' +
        'mismo, puede pedir solo el montaje en el tejado. Si los módulos ya están montados, puede ' +
        'pedir solo la instalación eléctrica (inversor, batería, alta en la compañía eléctrica) - ' +
        'ambos casos pasan por la misma comparación anónima de presupuestos.',
    },
  ],
  faq: [
    {
      q: '¿Cuántos presupuestos recibiré aproximadamente?',
      a: 'Las empresas instaladoras tienen entre 2 y 4 semanas para presentar un presupuesto - cuántos sean al final depende de la región y del tamaño del proyecto. Puede ver en todo momento cuántos presupuestos hay ya.',
    },
    {
      q: '¿Ven las empresas los presupuestos de la competencia?',
      a: 'No. Las empresas instaladoras solo ven el número de presupuestos ya enviados, no sus precios - y pueden ajustar el suyo en cualquier momento.',
    },
    {
      q: '¿Tengo que aceptar un presupuesto?',
      a: 'No, pedir y comparar presupuestos es sin compromiso. Al final usted decide libremente si acepta un presupuesto y cuál.',
    },
  ],
  primaryCta: { label: 'Comparar presupuestos gratis ahora', action: 'customer' },
  secondaryCta: { label: '¿Cuánto cuesta una instalación fotovoltaica?', action: 'link', href: '/coste-instalacion-fotovoltaica' },
  relatedLinks: [
    { label: 'Solicitar presupuesto fotovoltaico', href: '/solicitar-presupuesto-fotovoltaico' },
    { label: 'Encontrar instalador fotovoltaico', href: '/encontrar-instalador-fotovoltaico' },
    { label: 'Coste de una instalación fotovoltaica', href: '/coste-instalacion-fotovoltaica' },
    { label: '¿Solo necesita el montaje en el tejado?', href: '/montaje-paneles-solares' },
    { label: '¿Solo necesita la instalación eléctrica?', href: '/instalacion-electrica-fotovoltaica' },
    { label: 'Presupuestos sin teléfono ni correo electrónico', href: '/presupuesto-fotovoltaico-sin-telefono' },
  ],
}
